module.exports = "https://static.im-cdn.com/mjc/storefront/Accent/static/media/Ffacebook.3d90edb0.svg";